<template>
  <div>
    <tab-slide-configuration v-if="project" :project="project" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TabSlideConfiguration from '@/components/coding-admin/tab-slide-config.vue';
export default {
  components: {
    TabSlideConfiguration
  },

  data: function() {
    return {
      // project: null
    }
  },

  mounted() {
    const projectUid = this.$route.params.project_uid;
  },

  computed: {
    selectedLabel() {
      return `${this.selectedRows.length} ${this.selectedRows.length == 1 ? 'article' : 'articles'} selected`
    },
    ...mapState({
      user: state => state.user.user.data,
      project: state => state.projects.project.data,
    })
  },
};
</script>